// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1FIqW","title":"Info_title__23pEJ","selects":"Info_selects__2rK_o","requiredAsterisk":"Info_requiredAsterisk__2eeij"};